module.exports = __webpack_public_path__ + "static/media/aviso-privacidad.2d624ad2.pdf";